<template>
  <div>
    <b-card class="mt-2">
      <b-card-body>
        <validation-observer ref="AddServiceOrder" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted" @change="formChanged()">
            <b-row>
              <b-col md="6">
                <b-form-group label="Order Name*" label-for="mc-Order-name">
                  <validation-provider rules="required" #default="{ errors }" name="Order Name"
                    vid="Order Name">
                    <b-form-input id="mc-Order-name" placeholder="Order Name" v-model="details.orderName"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="HasPermission(PermissionList.Inventory_Create)">
                <b-form-group label="Warehouse*" label-for="textarea-default">
                  <validation-provider rules="required" v-slot="{ errors }" name="Warehouse" vid="Warehouse">
                        <b-form-select v-model="details.warehouseId" :disabled="viewOnly" :options="optionsWarehouse"
                        @change="validateWarehouse" />
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Time Estimation*" label-for="mc-Time-Estimation">
                  <validation-provider rules="required|min_value:0" #default="{ errors }" name="Time Estimation"
                    vid="Time Estimation">
                    <b-form-input id="mc-Time-Estimation" type="number" placeholder="Time Estimation"
                      v-model="details.timeEstimation" :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Appointment Date*" label-for="appointmentDate">
                  <validation-provider name="Appointment Date" :rules="{ required: true }" v-slot="{ errors }">
                    <b-form-datepicker id="appointmentDate" :min="new Date()" :disabled="viewOnly"
                      v-model="details.appointmentDate"></b-form-datepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Appointment Time*" label-for="appointmentTime">
                  <validation-provider name="Appointment Time" :rules="{ required: true }" v-slot="{ errors }">
                    <b-form-timepicker id="appointmentTime" :min="new Date()" v-model="details.appointmentTime"
                      :disabled="viewOnly" locale="en"></b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="Assign Staff" label-for="textarea-default">
                  <validation-provider :rules="{ required: true }" #default="{ errors }" name="Assign Staff"
                    vid="Assign Staff">
                    <b-form-select v-model="details.assignedStaffId" :options="staffOption" :disabled="viewOnly"
                      @change="assignStaffChanged" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="Assign Approver" label-for="textarea-default">
                  <validation-provider  #default="{ errors }" name="Assign Approver"
                    vid="Assign Approver">
                    <b-form-select v-model="details.assignedApproverId" :options="staffOption" :disabled="viewOnly"
                      @change="assignApproverChanged" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Price" label-for="mc-Price">
                  <validation-provider rules="min_value:0" #default="{ errors }" name="Price" vid="Price">
                    <b-form-input v-if="HasPermission(PermissionList.ServiceManagement_Finance)" id="mc-Price" placeholder="Price" step="0.01" type="number" v-model="details.price"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="First Name*" label-for="mc-First-name">
                  <validation-provider rules="required|max:250" #default="{ errors }" name="First Name"
                    vid="First Name">
                    <b-form-input id="mc-First-name" placeholder="First name" v-model="details.firstName"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Last Name*" label-for="mc-Last-name">
                  <validation-provider rules="required|max:250" #default="{ errors }" name="Last Name"
                    vid="Last Name">
                    <b-form-input id="mc-Last-name" placeholder="Last Name" v-model="details.lastName"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Email" label-for="mc-Email">
                  <validation-provider rules="email|min:0|max:250" #default="{ errors }" name="Email" vid="Email">
                    <b-form-input id="mc-Email" placeholder="Email" v-model="details.email" :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="ContactNo*" label-for="mc-ContactNo">
                  <validation-provider rules="required|numeric" #default="{ errors }" name="Contact No"
                    vid="Contact No">
                    <b-form-input id="mc-ContactNo" placeholder="Contact No" v-model="details.contactNo"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Comments" label-for="mc-Comments">
                  <validation-provider rules="min:0|max:250" #default="{ errors }" name="Comments" vid="Comments">
                    <b-form-input id="mc-Comments" placeholder="Comments" v-model="details.comments"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Location" label-for="mc-Location">
                  <validation-provider rules="min:0|max:250" #default="{ errors }" name="Location" vid="Location">
                    <b-form-input id="mc-Location" placeholder="Location" v-model="details.location"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Template" label-for="textarea-default">
                  <validation-provider :rules="{ required: true }" #default="{ errors }" name="Template" vid="Template">
                    <b-form-select v-model="details.selectedTemplateId" :options="template" @change="templateChanged"
                      :disabled="viewOnly" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Status" label-for="textarea-default">
                  <validation-provider :rules="{ required: true }" #default="{ errors }" name="Status" vid="Status">
                    <b-form-select v-model="details.status" :disabled="viewOnly" :options="statusOptions" @change="StatusChanged"
                     />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Reference Number" label-for="mc-Time-Estimation">
                  <b-form-input id="mc-Time-Estimation" type="text" readonly placeholder="Reference Number"
                    v-model="details.referenceNo" :disabled="viewOnly" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <!-- Items Section -->
    <b-card>
      <div ref="form" class="repeater-form" :style="{ height: trHeight }">
        <b-row v-for="(item, index) in invoiceData.items" :key="index" ref="row" class="pb-2">

          <!-- Item Dropdown -->
          <b-col cols="12" sm="6" lg="5">
            <b-form-group class="w-100">
              <!-- Display header for all screen sizes -->
              <span class="d-inline mb-1 font-weight-bold">Item*</span>
              <div v-if="optionsProduct.length === 0 || newProd"
                class="d-flex justify-content-center align-items-center w-100">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <div v-else class="flex-grow-1 w-100">
                <validation-provider rules="required" v-slot="{ errors }" name="Item" :vid="`Item${index}`">
                  <div class="align-items-center">
                    <v-select 
                      v-model="item.id" 
                      :options="optionsProduct" 
                      label="itemTitle" 
                      :disabled="viewOnly"
                      :clearable="false" 
                      append-to-body 
                      :reduce="option => option.value" 
                      class="w-100"
                      placeholder="Select Item" 
                      @input="(val) => updateItemForm(index, val)" 
                    />
                    <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                  </div>
                </validation-provider>
              </div>
            </b-form-group>
            </b-col>
            

            <!-- Quantity Input -->
            <b-col cols="12" sm="4" lg="5" class="qty-input">
              <b-form-group>
                <span class="d-inline d-lg-inline mr-2">Quantity*</span>
                <validation-provider rules="required|numeric|min_value:1" v-slot="{ errors }" name="Quantity"
                  :vid="`Quantity_${index}`">
                  <div class="flex-grow-1">
                    <b-form-input v-model="item.qty" step="1" :disabled="viewOnly" type="number" class="" />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Delete Icon -->
            <b-col cols="12" sm="2" lg="2" class="d-flex justify-content-center align-items-center">
              <b-button 
                variant="danger" 
                size="sm" 
                class="d-flex align-items-center" 
                @click="removeFromItemForm(index)"
              >
                Remove
              </b-button>
            </b-col>

        </b-row>
      </div>

      <b-row v-if="!viewOnly" class="align-items-center">
        <b-col md="2">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary" class="mr-2"
            @click="addNewItemInItemForm">
            Add Item

          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-body>
        <div>
          <div>
            <validation-observer ref="AddServiceOrderDetails" #default="{ invalid }">
              <b-form ref="tasks" :style="{ height: trHeight }" class="repeater-form">
                <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">
                  <!-- Tasks -->
                  <b-col md="4">
                    <b-form-group label="Tasks*" label-for="item-tasks">
                      <validation-provider rules="required|min:3|max:250" #default="{ errors }" name="Tasks"
                        vid="Tasks">
                        <b-form-input :id="`item-tasks_${index}`" type="text" placeholder="Enter your tasks"
                          v-model="item.tasks" :disabled="viewOnly" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Resources -->
                  <b-col md="2">
                    <b-form-group label="Resources" label-for="resources">
                      <validation-provider rules="required|min:0|max:250" #default="{ errors }" name="Resources" vid="Resources">
                        <b-form-input :id="`resources_${index}`" type="text" placeholder="Enter your resources"
                          v-model="item.resources" :disabled="viewOnly" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Tools -->
                  <b-col md="2">
                    <b-form-group label="Tools" label-for="tools">
                      <validation-provider rules="required|min:0|max:250" #default="{ errors }" name="Tools" vid="Tools">
                        <b-form-input :id="`tools_${index}`" type="text" placeholder="Enter your tools"
                          v-model="item.tools" :disabled="viewOnly" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Cost -->
                  <b-col lg="2" md="1">
                    <b-form-group label="Cost" label-for="price">
                      <validation-provider rules="required|numeric_decimal|min_value:0" #default="{ errors }" name="Price" vid="Price">
                        <b-form-input :id="`price_${index}`" step="0.01" type="number" placeholder="Enter your price"
                          v-model="item.price" :disabled="viewOnly" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Status -->
                  <b-col lg="2" md="1">
                    <b-form-group label="Status" label-for="Status">
                      <validation-provider #default="{ errors }" name="Status" vid="status">
                        <b-form-select :options="optionStatus" v-model="item.status" :disabled="viewOnly" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col lg="2" md="1">
                    <b-form-group label="Comment" label-for="Comment">
                      <validation-provider #default="{ errors }" name="Comment" vid="comment">
                        <b-form-textarea v-model="item.comment" :disabled="viewOnly"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Remove Button -->
                  <b-col v-if="!viewOnly" lg="2" md="3" class="mb-50">
                    <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-0 mt-md-2"
                      @click="removeItem(index)">
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr />
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
          <b-button v-if="!viewOnly" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="AddNew">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add New</span>
          </b-button>
          <b-row v-if="!viewOnly" class="justify-content-end">
            <b-col cols="auto">
              <b-button variant="outline-primary" class="btn btn-primary" @click="formSubmitted()">Update</b-button>
            </b-col>
            <!-- <b-col cols="auto">
                  <b-button variant="outline-primary" class="btn btn-success" @click="ApprovedServiceOrder()">Approve</b-button>
                </b-col>
                <b-col cols="auto">
                  <b-button variant="outline-primary" class="btn btn-danger" @click="DeclineServiceOrder()">Decline</b-button>
                </b-col>
                <b-col cols="auto">
                  <b-button variant="outline-primary" class="btn btn-warning" @click="RescheduleServiceOrder()">Reschedule</b-button>
                </b-col> -->
          </b-row>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <DocumentUpload
          @deleteFile="deleteFile"
          @downloadFile="downloadFile"
          @uploadFiles="uploadFiles"
          :documentDetails="documentDetails"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BForm,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormCheckbox,
  BFormFile,
  BContainer,
  BCard,
  BCardBody,
  BCardText,
  BSpinner,
  BFormDatepicker,
  BFormTimepicker
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { fnSortingDropdown } from "@/libs/customFn";
import { required, min, max } from "@validations";
import DocumentUpload from "../../../component/DocumentUpload.vue";
import { deleteDocumentSO, uploadMultipleDocuments, uploadDocument, downloadDocument } from '@/store/documentrepo/services';
import { customLoader, customError, customSwal, customErrorMessage } from '@/libs/customFn';
import '@/libs/customValidation';
import { ref, onUnmounted } from "@vue/composition-api";
import vSelect from "vue-select";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";

export default {
  components: {
    BFormSelect,
    BFormFile,
    BFormGroup,
    BForm,
    BFormTextarea,
    BFormInput,
    FormWizard,
    BContainer,
    BButton,
    BFormCheckbox,
    BCard,
    BCardBody,
    TabContent,
    BRow,
    BCol,
    ToastificationContent,
    BCardText,
    BSpinner,
    quillEditor,
    DocumentUpload,
    required,
    min,
    max,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
  },
  data() {
    return {
      id: this.$route.params.id,
      viewOnly: this.$route.meta.viewOnly,
      template: [],
      Status: [],
      initialAppointmentDate: null,
      optionsWarehouse: [],
      details: {
        id: null,
        referenceNo: null,
        orderName: null,
        warehouseId: null,
        orderDescription: null,
        appointmentDate: null,
        appointmentTime: null,
        timeEstimation: null,
        template: [],
        firstName: null,
        lastName: null,
        email: null,
        contactNo: null,
        comments: null,
        location: null,
        status: null,
        assignedStaffName: null,
        assignedStaffEmail: null,
        assignedStaffId: null,
        assignedApproverName: null,
        assignedApproverEmail: null,
        assignedApproverId: null,
        selectedTemplateId: null,
        assignStaffDetails: null,
        assignApproverDetails: null,
      },
      budget: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      defaultItem: [
        {
          "tasks": null,
          "resources": null,
          "tools": null,
          "price": 0.00,
          "status": null,
          "comment": null,
        }
      ],
      items: [],
      nextTodoId: 1,
      documentDetails: {

        isDelete: false,
        documentList: [],

      },
      statusOptions: [
        { value: "BOOKING_PENDING", text: "Booking Pending" },
        { value: "BOOKING_CANCELLED", text: "Booking Cancelled" },
        { value: "BOOKING_CONFIRMED", text: "Booking Confirmed" },
        { value: "SR_IN_PROGRESS", text: "Service In Progress" },
        { value: "SR_APPROVED", text: "Service Approved" },
        { value: "SR_COMPLETED", text: "Service Completed" },
        { value: "SR_INVOICED", text: "Service Invoiced" },
      ],
      optionsProduct: [],
      item: {
        qty: 1,
      },
      optionStatus: [
        { value: "NEW", text: "NEW" },
        { value: "INPROGRESS", text: "INPROGRESS" },
        { value: "COMPLETED", text: "COMPLETED" }
      ],
      // add product modal
      prodName: "",
      prodQty: null,
      newProd: false,
      selectedCurrency: "MUR",
      currencyOptions: [],
      staffOption: [],
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      exchangeRate: 1,
      barcode: null,
      loadingButton: false,
      selectedProduct: null,
      products: [],
    };
  },
  watch: {
    "ServiceTemplateObject.budget"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.budget = 0;
      }
    },
    "ServiceTemplateObject.estimatedDuration"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.estimatedDuration = 0;
      }
    },
  },
  methods: {
    ...mapActions("serviceModule", ["getServiceTemplateListAction", "getStaffForTemplateListAction", "getServiceTemplateByIDAction", "postServiceOrderAction", "getServiceTemplateByReferenceNoAction", "putServiceOrderAction", "approveOrCancelAction", "rescheduleAction", "getServiceOrderDocumentsAction", "postServiceOrderDocumentAction", "removeServiceOrderDocumentAction"]),
    ...mapActions("employeeModule", ["getEmployeeListAction", "getEmployeeByIdAction"]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
      "getProductIDAction",
    ]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    StatusChanged(selectedValue) {
      if (selectedValue === 'SR_COMPLETED') {
        
      }
    },
    showSuccess() {
      this.$swal({
        title: "Service Order Updated!",
        text: "You have successfully Updated a Service Order!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        this.$router.push({ name: "serviceorder-list" });
      });
    },
    showProcessingDialog(text = 'Please wait while the data is being loaded') {
      this.processingData = this.$swal({
        title: 'Processing...',
        text: text,
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
    },
    hideProcessingDialog() {
      if (this.processingData) {
        this.processingData.close();
        this.processingData = null;
      }
    },
    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document(s) is being added',
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const serviceOrderId = this.details.serviceOrderId;
      console.log("serviceOrderId: ", this.details.serviceOrderId);
      // if (selectedFiles.length > 1) {

      //   await uploadMultipleDocuments(selectedFiles, serviceOrderId)
      //     .then((response) => {
      //       customSwal('Your file(s) have been successfully uploaded.');
      //       loader.close();
      //     })
      //     .catch((error) => {
      //       customError(error);
      //       loader.close();
      //     });
      // } else if (selectedFiles.length < 2) {
      //   await uploadDocument(selectedFiles, serviceOrderId)
      //     .then((response) => {
      //       customSwal('Your file(s) have been successfully uploaded.');
      //       loader.close();
      //     })
      //     .catch((error) => {
      //       customError(error);
      //       loader.close();
      //     });
      // }
      let docForm = new FormData();
      docForm.append("ServiceOrderId", serviceOrderId);
      //docForm.append("File", selectedFiles[0]);
      selectedFiles.forEach((file) => {
        docForm.append("File", file);
        console.log("File: ", file); // The key "File" matches the property in your payload
      });
      await this.postServiceOrderDocumentAction(docForm).then((response) => {
        customSwal('Your file(s) have been successfully uploaded.');
        loader.close();
      })
        .catch((error) => {
          customError(error);
          loader.close();
        });
      //selectedFiles = [];

      await this.getServiceOrderDocumentsAction(serviceOrderId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      loader.close();
      this.$nextTick(() => {
        this.$bvModal.show('modal-view-testdocument');
      });
    },
    async deleteFile(id) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being deleted',
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      
      //await deleteDocument(id)
      await deleteDocumentSO(id)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal();
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getServiceOrderDocumentsAction(this.details.serviceOrderId);
      //console.log("documentDetails: ", documentDetails);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show('modal-view-testdocument');
      });
    },
    formChanged() {
    },
    async templateChanged(newValue) {
      try {
        this.showProcessingDialog("Retrieving template's sub-tasks");
        await this.getServiceTemplateByIDAction(newValue).then(() => {
          this.items = ((this.ServiceTemplateObject != null && this.ServiceTemplateObject.orderTemplateDetails != null) ? this.ServiceTemplateObject.orderTemplateDetails : []);
          this.details.selectedTemplateId = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.id : 0);
          this.details.price = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.budget : 0);
          this.details.timeEstimation = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.estimatedDuration : 0);
          this.initTrHeight();
        });
        this.hideProcessingDialog();
      }
      catch (error) {
        console.error("Error fetching service template list:", error);
      }
    },
    async assignStaffChanged(selectedId) {
      try {
        if (selectedId == undefined || selectedId == null) {
          return;
        }
        this.details.assignStaffDetails = null;
        this.details.assignedStaffId = null;
        if (this.staffList != null) {
          let staffDetails = this.staffList.filter((v) => v.id == selectedId)[0];
          if (staffDetails != null) {
            let reqDetails = {
              assignedStaffName: `${staffDetails.firstName} ${staffDetails.lastName}`,
              assignedStaffEmail: staffDetails.email,
              userId: selectedId
            };

            this.details.assignedStaffName = `${staffDetails.firstName} ${staffDetails.lastName}`;
            this.details.assignedStaffEmail = staffDetails.email;
            this.details.assignedStaffId = selectedId;
            this.details.assignStaffDetails = reqDetails;
          }
        }
      } catch (error) {
        console.error("Error fetching staff details:", error);
      }
    },
    async assignApproverChanged(newValue) {
      try {
        this.details.assignApproverDetails = null;
        this.details.assignedApproverId = null;
        this.showProcessingDialog("Processing assigned approver");

        if (this.staffList != null) {
          let staffDetails = this.staffList.filter((v) => v.id == newValue)[0];
          if (staffDetails != null) {
            let reqDetails = {
              assignedStaffName: `${staffDetails.firstName} ${staffDetails.lastName}`,
              assignedStaffEmail: staffDetails.email,
              userId: newValue
            };
            this.details.assignedApproverName = `${staffDetails.firstName} ${staffDetails.lastName}`;
            this.details.assignedApproverEmail = staffDetails.email;
            this.details.assignedApproverId = newValue;
            this.details.assignApproverDetails = reqDetails;
          }
        }
        this.hideProcessingDialog();
      }
      catch (error) {
        console.error("Error fetching staff details:", error);
      }
    },
    isWithin48Hours() {
      const now = new Date(); // Current time
      const appointmentDateTime = new Date(this.details.appointmentDateTime); // Your appointment datetime

      // Calculate the difference in milliseconds
      const diffInMilliseconds = appointmentDateTime - now;

      // Convert milliseconds to hours
      const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

      // Check if it's within 48 hours
      return diffInHours <= 48 && diffInHours >= 0;
    },
    isAppointmentInPast() {
      if (this.initialAppointmentDate != this.details.appointmentDate) {
        const now = new Date(); // Current date and time
        return this.details.appointmentDateTime < now;
      }
      return false;
    },
    // combineAppointmentDateTime() {
    //   const date = new Date(this.details.appointmentDate);
    //   const time = this.details.appointmentTime;

    //   console.log("Date (Before setting time):", date);
    //   console.log("Time:", time);

    //   if (date && time) {
    //     const [hours, minutes] = time.split(':').map(Number); // Ensure time is split correctly and parsed as numbers

    //     // Ensure hours and minutes are valid numbers before setting
    //     if (!isNaN(hours) && !isNaN(minutes)) {
    //       date.setHours(hours);
    //       date.setMinutes(minutes);
    //       date.setSeconds(0);  // Optional: Set seconds to 0 if needed
    //       date.setMilliseconds(0);  // Optional: Set milliseconds to 0 if needed

    //       console.log("Date (After setting time):", date);
    //       this.details.appointmentDateTime = date;
    //     } else {
    //       console.error("Invalid time format");
    //     }
    //   } else {
    //     console.error("Invalid date or time");
    //   }
    combineAppointmentDateTime() {
  const date = new Date(this.details.appointmentDate);
  const time = this.details.appointmentTime;

  console.log("Date (Before setting time):", date);
  console.log("Time:", time);

  if (date && time) {
    const [hours, minutes] = time.split(":").map(Number);

    if (!isNaN(hours) && !isNaN(minutes)) {
      // Set time
      date.setUTCHours(hours);
      date.setUTCMinutes(minutes);
      date.setUTCSeconds(0);
      date.setUTCMilliseconds(0);

      console.log("Date (After setting time, UTC):", date.toISOString());
      this.details.appointmentDateTime = date.toISOString(); // Ensure UTC time is used
    } else {
      console.error("Invalid time format");
    }
  } else {
    console.error("Invalid date or time");
  }
    },
    async ApprovedServiceOrder() {

      let payload = {
        "bookingStatus": "Approved",
        "referenceNo": this.details.referenceNo,
        "reason": "-"
      };

      this.showProcessingDialog("Please wait while the data is being process");
      this.approveOrCancelAction({ payload })
        .then(() => {
          this.hideProcessingDialog();
          customSwal("Service Order Approved!")
        })
        .catch((ex) => {
          console.log("exx:", ex);
          console.error("Error Details:", ex);
          customError(ex);
        });
    },
    async DeclineServiceOrder() {
      if (this.isWithin48Hours()) {
        customErrorMessage("Appointments cannot be rescheduled, or canceled within 48 hours of the appointment time", "Appointment Date/Time");
        return;
      }
      let payload = {
        "appointmentDate": "Cancelled",
        "referenceNo": this.details.referenceNo,
        "reason": "-"
      };

      this.showProcessingDialog("Please wait while the data is being process");
      this.approveOrCancelAction({ payload })
        .then(() => {
          this.hideProcessingDialog();
          customSwal("Service Order Decline!")
        })
        .catch((ex) => {
          console.log("exx:", ex.errors);
          console.error("Error Details:", ex);
          customError(ex);
        });
    },
    async RescheduleServiceOrder() {
      if (this.isWithin48Hours()) {
        customErrorMessage("Appointments cannot be rescheduled, or canceled within 48 hours of the appointment time", "Appointment Date/Time");
        return;
      }
      this.combineAppointmentDateTime();

      if (this.isAppointmentInPast()) {
        customErrorMessage("The Date/Time is in the past", "Appointment Date/Time");
        return;
      }
      let payload = {
        "appointmentDate": this.details.appointmentDate,
        "referenceNo": this.details.referenceNo,
        "reason": "-"
      };

      this.showProcessingDialog("Please wait while the data is being process");
      this.rescheduleAction({ payload })
        .then(() => {
          this.hideProcessingDialog();
          customSwal("Service Order Rescheduled!")
        })
        .catch((ex) => {
          console.error("Error Details:", ex);
          customError(ex);
        });
    },
    async formSubmitted() {
      const isValidMainForm = await this.$refs.AddServiceOrder.validate();
      const isValidSubForm = await this.$refs.AddServiceOrderDetails.validate();
      const hasValue = this.items.length > 0 ? true : false;
      const assignStaff = (this.details.assignedStaffId != null) ? true : false;
      const assignApprover = (this.details.assignedApproverId != null) ? true : false;

      if (this.isAppointmentInPast()) {
        customErrorMessage("The Date/Time is in the past", "Appointment Date/Time");
        return;
      }

      if (!hasValue) {
        customErrorMessage("Please provide at least one template detail", "Template Detail");
        return;
      }

      if (!assignStaff) {
        customErrorMessage("Please assign a staff for this service order", "Assign staff");
        return;
      }

      // if (!assignApprover) {
      //   customErrorMessage("Please assign a approver for this service order", "Assign approver");
      //   return;
      // }

      if (isValidMainForm && isValidSubForm) {
        let templateDetails = [];
        if (this.items != null && this.items.length > 0) {
          this.items.forEach((detail, index) => {
            var obj = {};
            console.log(" this.items.forEach((detail, index) => {", detail);
            obj["salesReferenceID"] = "0";
            obj["tasks"] = detail.tasks;
            obj["resources"] = detail.resources;
            obj["tools"] = detail.tools;
            obj["price"] = detail.price;
            obj["comment"] = detail.comment;
            obj["estimatedDuration"] = detail.estimatedDuration;
            obj["status"] = detail.status;
            templateDetails.push(obj)
          });
        } else {
          templateDetails = null;
        }

        const mappedProducts = this.invoiceData.items
          .map((item) => {
            const ProductId = item.id.toString();
            const Quantity = item.qty;
            // Return an object only if ProductId exists
            return ProductId ? { ProductId, Quantity } : null;
          })
          .filter((item) => item !== null); // Filter out null values

        console.log('mappedProducts ', mappedProducts)
        this.combineAppointmentDateTime();

        let payload = {
          orderTemplateName: this.details.orderName,
          firstName: this.details.firstName,
          lastName: this.details.lastName,
          email: this.details.email,
          ContactNo: this.details.contactNo,
          comments: this.details.comments,
          location: this.details.location,
          timeEstimation: this.details.timeEstimation,
          appointmentDateTime: this.details.appointmentDateTime,
          AssignedApprover: this.details.assignedApproverId,
          AssignedTechnician: this.details.assignedStaffId,
          price: this.details.price,
          status: this.details.status,
          serviceOrderId: this.details.serviceOrderId,
          orderTemplateId: this.details.selectedTemplateId,
          orderDetails: templateDetails,
          quantity: 0,
          warehouseId: this.details.warehouseId,
          serviceOrderProducts: JSON.parse(JSON.stringify(mappedProducts)),
          assignStaffDetails: [
            {
              assignedStaffName: this.details.assignedStaffName,
              assignedStaffEmail: this.details.assignedStaffEmail,
              userId: this.details.assignedStaffId
            },
          ],
          assignApproverDetails: {
            assignedStaffName: this.details.assignedApproverName,
            assignedStaffEmail: this.details.assignedApproverEmail,
            userId: this.details.assignedApproverId
          },
        };

        console.log("Payload:", payload);
        this.showProcessingDialog("Please wait while the data is being process");
        this.putServiceOrderAction({ payload })
          .then(() => {
            this.hideProcessingDialog();
            this.showSuccess();
           // customSwal("Service Order updated!")
          })
          .catch((ex) => {
          // Extracting the error message from the response
          const errorMessage = ex.response?.data?.message || "An unexpected error occurred.";
    
          console.error("Error Details:", {
            message: ex.message,
            response: ex.response,
            status: ex.response?.status,
            data: ex.response?.data, 
          });

          customErrorMessage(errorMessage, "Cannot process your request.");
          });
      }
      else {
        customErrorMessage("Please fill out all required fields.", "Required Fields");
      }
    },

    validateWarehouse() {
  const whouseId = this.details.warehouseId;
  console.log("warehouseid", whouseId);

  const warehousedet = this.warehouse.find(wh => wh.id === whouseId);
  console.log("warehouse", warehousedet);
  if (warehousedet && warehousedet.itemBalance && Array.isArray(warehousedet.itemBalance)) {
    const count = warehousedet.itemBalance.length; 
    if (count === 0) {
      this.errorWarehouse();
      return;
    }
  } else {
   
    console.error("Warehouse or itemBalance data is missing.");
    this.errorWarehouse();
    return;
  }
},

    errorWarehouse(data) {
      let msg = null;
     // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "No stock available in the selected warehouse.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    AddNew() {
      let dynamicValue = this.defaultItem.length > 0 ? this.defaultItem[0] : [];
      let clonedValue = Object.assign({}, dynamicValue); // Shallow copy
      this.items.push(clonedValue);
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    removeFromItemForm(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight('form', null);
      this.trSetHeight('tasks', null);
      this.$nextTick(() => {
        this.trSetHeight('form', this.$refs.form.scrollHeight);
        this.trSetHeight('tasks', this.$refs.tasks.scrollHeight);
      });
    },
    async loadProductList() {
      await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
            });
          }
        });
      });
      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },

    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  beforeMount() {
    //this.getProductListAction(true);
  },
  async mounted() {
    try {
      this.showProcessingDialog("Retrieving templates");
      if (HasPermission(PermissionList.Inventory_Create)){
      if (this.ProductList == undefined || this.ProductList.length == 0)
        //await this.getProductListAction(true);
        await this.loadProductList();
      }

      await this.getServiceTemplateByReferenceNoAction(this.id).then(() => {
        this.details = this.ServiceTemplateObject ?? [];

        this.items = ((this.ServiceTemplateObject != null && this.ServiceTemplateObject.serviceOrderDetails	 != null) ? this.ServiceTemplateObject.serviceOrderDetails	 : []);
          this.details.selectedTemplateId = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.serviceOrderTemplateId : 0);
          this.details.price = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.price : 0);
          this.details.timeEstimation = ((this.ServiceTemplateObject != null) ? this.ServiceTemplateObject.estimatedDuration : 0);

          this.invoiceData.items = (
        this.ServiceTemplateObject.serviceOrderProducts ?? []
      ).map((product) => {
        const matchingProduct = this.ProductList.find(
          (p) => p.id === product.productId
        );

        return {
          id: {
            value: product.productId,
            itemTitle: matchingProduct
              ? matchingProduct.name
              : "Unknown Product",
          },
          name: matchingProduct ? matchingProduct.name : "Unknown Product",
          qty: product.quantity,
          price: product.price, // Include price if you want to display it
        };
      });


        console.log(this.ServiceTemplateObject, "ServiceTemplateObject");

        this.getServiceTemplateByIDAction(this.ServiceTemplateObject.serviceOrderTemplateId).then(() => {
          
          //this.products = ((this.ServiceTemplateObject != null && this.ServiceTemplateObject.orderTemplateProducts != null) ? this.ServiceTemplateObject.orderTemplateProducts : []);
        
          this.initTrHeight();
        });

        if (this.ServiceTemplateObject) {
          this.details.appointmentDate = this.ServiceTemplateObject.appointmentDateTime;
          this.details.orderName = this.ServiceTemplateObject.orderTemplateName;
          this.details.assignedStaffId = this.ServiceTemplateObject.assignedTechnician;
          this.details.assignedApproverId = this.ServiceTemplateObject.assignedApprover;
          this.details.selectedTemplateId = this.ServiceTemplateObject.serviceOrderTemplateId;
          this.details.timeEstimation = this.ServiceTemplateObject.estimatedDuration;
          this.details.referenceNo = this.ServiceTemplateObject.referenceNo;
          this.details.serviceOrderId = this.ServiceTemplateObject.serviceOrderId;
          
          this.initialAppointmentDate = this.details.appointmentDate;
          if (this.ServiceTemplateObject.appointmentDateTime) {
            let dateObj = new Date(this.ServiceTemplateObject.appointmentDateTime);
            if (!isNaN(dateObj.getTime())) {
              const hours = dateObj.getHours().toString().padStart(2, '0');
              const minutes = dateObj.getMinutes().toString().padStart(2, '0');
              this.details.appointmentTime = `${hours}:${minutes}`;
            } else {
              console.error("Invalid Date:", dateTime);
            }
          }
         this.items = this.ServiceTemplateObject.serviceOrderDetails ?? [];
          this.products = this.ServiceTemplateObject.serviceOrderProducts ?? [];

          // // Process each item
          // for (const { ProductId, Quantity } of this.products) {
          //   const product = this.getProductIDAction(ProductId);
          //   if (product) {
          //     const { id, name , batchQuantity} = product;
          //     this.invoiceData.items.push({
          //       id,
          //       name,
          //       batchQuantity
          //     });
          //   }
          // }

          //console.log("itemsssssssssssss", this.products);
          this.invoiceData.items = this.products
            .map((item) => {
              console.log('styored items: ', item);
              const prod = this.optionsProduct.filter((v) => v.value == item.productId)[0];
              const id = item.productId;
              const name = prod.name;
              const qty = item.quantity;

              // Return an object only if ProductId exists
              return id ? { id, name, qty } : null;
            })
            .filter((item) => item !== null); // Filter out null values
        }
      });

      this.initTrHeight();
      await this.getServiceTemplateListAction().then(() => {
        this.template = [];
        this.servicerequests.map((v, i) =>
          this.template.push({
            value: v.id,
            text: `${v.orderName}`,
          })
        )
      });

      await this.getServiceOrderDocumentsAction(this.ServiceTemplateObject.serviceOrderId)
        .then(() => {

          console.log("docs",this.documents);
          this.documentDetails.documentList = this.documents ?? null;
          this.documentDetails.isDelete = true;
        });

      if (this.details.assignedStaffId != null) {
        if (this.staffList != null) {
          let staffDetails = this.staffList.filter((v) => v.id == this.details.assignedStaffId)[0];
          if (staffDetails != null) {
            let reqDetails = {
              assignedStaffName: `${staffDetails.firstName} ${staffDetails.lastName}`,
              assignedStaffEmail: staffDetails.email,
              userId: this.details.assignedStaffId
            };

            this.details.assignedStaffName = `${staffDetails.firstName} ${staffDetails.lastName}`;
            this.details.assignedStaffEmail = staffDetails.email;
            this.details.assignStaffDetails = reqDetails;
          }
        }
      }
      if (this.details.assignedApproverId != null) {
        if (this.staffList != null) {
          let staffDetails = this.staffList.filter((v) => v.id == this.details.assignedApproverId)[0];
          let reqDetails = {
            assignedStaffName: `${staffDetails?.firstName} ${staffDetails?.lastName}`,
            assignedStaffEmail: staffDetails?.email,
            userId: this.details.assignedApproverId
          };

          this.details.assignedStaffName = `${staffDetails?.firstName} ${staffDetails?.lastName}`;
          this.details.assignedApproverEmail = staffDetails?.email;
          this.details.assignStaffDetails = reqDetails;
        }
      }

      this.hideProcessingDialog();
    }
    catch (error) {
      console.error("Error fetching service template list:", error);
    }
    try {
      this.showProcessingDialog("Retrieving staff details");
      await this.getStaffForTemplateListAction()
        .then(() => {
          this.staffOption = this.staffList.map(option => {
            return {
              value: option.id,
              text: option.firstName + option.lastName
            };
          });
        });
      this.details.assignedStaffId = this.ServiceTemplateObject.assignedTechnician; // Set the pre-selected staff ID
      this.details.assignedApproverId = this.ServiceTemplateObject.assignedApprover; // Set the pre-selected approver ID

      console.log("warehouse", this.ServiceTemplateObject);
      //this.details.warehouseId = this.ServiceTemplateObject.warehouseId.id;

      if (HasPermission(PermissionList.Inventory_Create) && (this.warehouse == undefined || this.warehouse.length == 0))
      await this.getWarehouseListAction();

    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );
    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);

      this.hideProcessingDialog();
    }
    catch (error) {
      console.error("Error fetching users list:", error);
    }
    this.initTrHeight();
  },
  setup() {
    const itemFormBlankItem = {
      id: null,
      name: null,
      qty: 1
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val) => {
      const selectedOption = this.optionsProduct.find(option => option.value === val);
      if (selectedOption) {
        // Update the relevant fields
        this.invoiceData.items[index].id = selectedOption.value;
        this.invoiceData.items[index].name = selectedOption.itemTitle;
        this.invoiceData.items[index].qty = this.invoiceData.items[index].qty || 1;
      }
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      PermissionList,
      HasPermission
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      loading: "loading",
      servicerequests: "servicerequests",
      ServiceTemplateObject: "serviceOrderOne",
      documents: "serviceOrderDocuments",
      
      staffList: "stafflistrequests",
      file: 'file'
    }),
    ...mapGetters("employeeModule", {
      employees: "employees",
      employeeDetails: "employeeid"
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    templateDDL() {
      if (!this.servicerequests || !Array.isArray(this.servicerequests)) {
        return [];
      }
      return fnSortingDropdown(this.template);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
</style>

<style lang="scss">
.form-item-section {
  //  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    // background-color: $theme-dark-body-bg;

    .row .border {
      //    background-color: $theme-dark-card-bg;
    }
  }
}
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.item-selector-title {
  width: 100%;
  max-width: 300px;
  /* Optional to limit max width on larger screens */
}

@media (max-width: 768px) {
  .item-selector-title {
    width: 100%;
  }
}
</style>
